export default __webpack_public_path__ + "static/media/Gas.5a9e86b4.svg";